import React, { useState, useEffect } from "react";

import { ReactComponent as CallBackIcon } from "../assets/Call-Made.svg";

const CollapsibleTab = ({
  heading,
  label,
  content,
  onMouseEnter,
  onMouseLeave,
  index,
  activeTabIndex,
  backgroundColor,
  textColor,
  collapsedWidth,
  href,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 850);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 850);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isActive = isMobile || activeTabIndex === index;
  const widthClass = isActive
    ? collapsedWidth
    : activeTabIndex > index
      ? "w-0"
      : collapsedWidth;

  const handleClick = () => {
    if (href) {
      window.open(href, "_blank");
    }
  };

  return (
    <section
      className={`
        absolute top-0 left-0 justify-center items-center transition-all duration-300 h-full max-sm:min-h-[100px] max-sm:w-full max-sm:flex
        ${widthClass}
        ${backgroundColor}
      `}
      style={{
        zIndex: 100 - index,
        cursor: index === 0 ? "default" : "pointer",
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleClick}
      role="button"
      aria-pressed={isActive}
      tabIndex={0}
    >
      <div className="relative flex justify-between items-center w-full h-full">
        {isActive && (
          <div
            className={`flex flex-col items-start text-left w-full ${textColor} md:pl-[40px]`}
          >
            <h1 className="text-[20px] max-sm:hidden">{heading}</h1>
            <h1 className="text-[100px] max-sm:hidden">{label}</h1>
            <p className="text-[25px] pr-[30%] max-sm:hidden">{content}</p>
            <h1
              className={`text-[25px] sm:hidden ${index === 0 ? "hidden" : ""} pl-[50px]`}
            >
              {label}
            </h1>
          </div>
        )}

        <div
          className={`transition-transform duration-300 ${index === 0 || (activeTabIndex > index && !isMobile) ? "hidden" : ""} flex-shrink-0`}
          style={{
            position: "absolute",
            top: 0,
            right: "0",
            width: isMobile ? "50px" : "200px",
            height: isMobile ? "50px" : "200px",
          }}
        >
          <CallBackIcon
            alt="Call Back"
            className="w-full h-full"
            fill={isActive ? textColor.replace("text-", "") : "black"}
            opacity={isActive ? 1 : 0.54}
          />
        </div>
      </div>
    </section>
  );
};

const StaticTab = ({ label, backgroundColor, textColor, href }) => {
  const handleClick = () => {
    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <section
      className={`${backgroundColor} ${textColor} h-[70px] flex items-center justify-between px-[20px] text-[20px] cursor-pointer`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      <div className="flex items-center">
        <h1>{label}</h1>
      </div>
      <div className="w-[60px] h-[60px]">
        <CallBackIcon
          alt="Call Back"
          className="w-full h-full"
          fill={textColor.replace("text-", "")}
        />
      </div>
    </section>
  );
};

export { CollapsibleTab, StaticTab };
